import React, { memo } from 'react';
import { Cell, FieldGroup, Row } from '@dexma/ui-components';

import { WidgetType } from 'domain/entity/widget';
import { PanelWidgetType } from 'adapter/in/common/widget/WidgetTypePreset/types';

type PanelFieldGroupOptions = {
    options: PanelWidgetType[];
    selectedValue: WidgetType;
};

export type WidgetConfig = {
    presetWidgetTypes: PanelFieldGroupOptions;
    onWidgetClick: (widget: PanelWidgetType) => void;
};
const PanelWidgetTypePreset = memo((props: WidgetConfig) => {
    const { presetWidgetTypes, onWidgetClick } = props;
    const { options } = presetWidgetTypes;

    return (
        <Row alignItems='start' data-testid='panel-widget-type-preset'>
            <Cell className='widget-type-block'>
                <FieldGroup
                    selectedValues={presetWidgetTypes.selectedValue}
                    variant='custom'
                    size='medium'
                    values={options ?? []}
                    isLoading={!options || options.length === 0}
                    onChange={onWidgetClick}
                />
            </Cell>
        </Row>
    );
});

export default PanelWidgetTypePreset;
